// import Separation from './Separation';

export default {
  // component: Separation,
  component: load(() => import(/* webpackChunkName: "Feed-Report-Separation" */ './Separation')),
  permissions: ['ReportOrderMenu'],
  name: app.translate('routes.home.feed.Separation'),
  icon: 'clipboard-check',
  drawer: false,
};
